var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoRemoveGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#B1AEB8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9742 13.8242C13.2089 14.0589 13.5893 14.0589 13.824 13.8242C14.0587 13.5896 14.0587 13.2091 13.824 12.9744L10.8498 10.0002L13.824 7.02605C14.0587 6.79139 14.0587 6.41093 13.824 6.17627C13.5893 5.94161 13.2089 5.94161 12.9742 6.17627L10 9.15047L7.02578 6.17624C6.79112 5.94158 6.41066 5.94158 6.176 6.17624C5.94134 6.4109 5.94134 6.79135 6.176 7.02601L9.15024 10.0002L6.17599 12.9745C5.94133 13.2091 5.94134 13.5896 6.17599 13.8243C6.41065 14.0589 6.79111 14.0589 7.02577 13.8243L10 10.85L12.9742 13.8242Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRemoveGrey);
export default __webpack_public_path__ + "static/media/ico_remove_grey.21cbf505a961cdf892bac16d264187a4.svg";
export { ForwardRef as ReactComponent };